import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {HeaderModule} from "../../../shared/component/common/header/header.module";
import {ButtonModule} from "../../../shared/component/common/button/button.module";
import {LabelModule} from "../../../shared/component/common/label/label.module";
import {PepComponent} from "./pep.component";



@NgModule({
  declarations: [PepComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
  ]
})
export class PepModule { }
